module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_footer_an-dfa1d3044073daf1ce150360853dc766.svg";